import { render, staticRenderFns } from "./jiuyeForm.vue?vue&type=template&id=138c114f&scoped=true"
import script from "./jiuyeForm.vue?vue&type=script&lang=js"
export * from "./jiuyeForm.vue?vue&type=script&lang=js"
import style0 from "./jiuyeForm.vue?vue&type=style&index=0&id=138c114f&prod&scoped=true&lang=less"
import style1 from "./jiuyeForm.vue?vue&type=style&index=1&id=138c114f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138c114f",
  null
  
)

export default component.exports